import { useState } from 'react'

interface IUploadTripImageProps {
  file: Blob
  venueId: number
  roomId: number
  key: string
  isHero: boolean
}

export const useUploadTripImage = () => {
  const [loading, setLoading] = useState(false)

  const uploadTripImage = async ({
    file,
    venueId,
    roomId,
    key,
    isHero,
  }: IUploadTripImageProps) => {
    setLoading(true)

    const formData = new FormData()
    formData.append('file', file)
    formData.append('venueId', venueId as any)
    formData.append('key', key)

    if (roomId) formData.append('roomId', roomId as any)
    if (isHero) formData.append('isHero', isHero as any)

    try {
      const responseRaw = await fetch(
        `${process.env.REACT_APP_API_URL}/list-venue/upload/` || '',
        {
          body: formData,
          method: 'POST',
        }
      )

      const { status, ok } = responseRaw
      const obj = await responseRaw.json()

      const { error } = obj

      let success = ok
      if (typeof error !== 'undefined') {
        success = !error
      }
      setLoading(false)

      return { content: obj, status, success }
    } catch (err: any) {
      setLoading(false)
      return {
        content: err,
        message: err?.message,
        status: 0,
        success: false,
      }
    }
  }

  return {
    uploadTripImage,
    loading,
  }
}
